import { configureStore, combineReducers } from 'redux-starter-kit';
import { connectRouter, routerMiddleware } from 'connected-react-router';
import { reducer as formReducer } from 'redux-form';
import { history } from 'consts/routes';
import { connect } from 'react-redux';
import thunk from 'redux-thunk';
//reducers
import baseReducer from './modules/Base/reducer';
import metaReducer from './modules/Meta/reducer';
import authReducer from './modules/Auth/reducer';
import caseReducer from './modules/Case/reducer';
import portfolioBuilderReducer from './modules/PorfolioBuilder/reducer';
import questionnareReducer from './modules/Quesionnare/reducer';
import firmReducer from './modules/Firm/reducer';
import messageReducer from './modules/WebSocket/reducer';
import advisorReducer from './modules/Advisor/reducers';
import policyImportReducer from './modules/PolicyImport/reducer';
import dragAndDropReducer from './modules/DragAndDrop/reducer';
import fundsAndMpsRefReducer from './modules/FundsAndMpsCipRef/reducer';
import riskMappingResultsReducer from './modules/RiskMapping/reducer';
import capacityForLossReducer from './modules/CapacityForLoss/reducer';
import experienceReducer from './modules/Experience/reducer';
import reportReducer from './modules/Report/reducer';
import cipReducer from './modules/CIP/reducer';
import investmentAnalyserReducer from './modules/InvestmentAnalyser/reducer';
// actions
import actions from 'store/actions';
// selectors
import selectors from 'store/selectors';
import { invalidationMiddleware } from './middleware';

const rootReducer = combineReducers({
  router: connectRouter(history),
  base: baseReducer,
  meta: metaReducer,
  form: formReducer,
  auth: authReducer,
  case: caseReducer,
  portfolioBuilder: portfolioBuilderReducer,
  questionnare: questionnareReducer,
  firm: firmReducer,
  messages: messageReducer,
  advisor: advisorReducer,
  importPolicies: policyImportReducer,
  dragAndDrop: dragAndDropReducer,
  fundsAndMpsRef: fundsAndMpsRefReducer,
  riskMappingResults: riskMappingResultsReducer,
  capacityForLoss: capacityForLossReducer,
  experience: experienceReducer,
  report: reportReducer,
  cip: cipReducer,
  investmentAnalyser: investmentAnalyserReducer
});

export const store = configureStore({
  reducer: rootReducer,
  middleware: [thunk, routerMiddleware(history), invalidationMiddleware] as any
});

// @ts-ignore
if (window.Cypress) {
  // @ts-ignore
  window.testStore = store;
}

export default {
  connect,
  actions: actions,
  selectors: selectors
};
